<template>
  <div class="all-filter-container flex-column-layout">
    <UiButton
      :text="$t('products.filters.clearAllFilters')"
      :is-disabled="isBtnDisabled"
      class="clear-filter-button"
      @clicked="onClearAllClicked"
    />
    <BrandFilter
      v-if="brandFilters.length"
      :filter-data="brandFilters"
      :is-resetted="resetComponent"
      @resetted="() => trackComponentReset('brands')"
    />
    <UiDivider :type="'primary'" />
    <PriceFilter
      :price-range-filter="priceRangeFilter"
      :is-resetted="resetComponent"
      @resetted="() => trackComponentReset('priceRange')"
    />
    <TypeFilter v-if="typeFilters.length" :filter-data="typeFilters" />
    <OtherFilter v-if="otherFilters.length" :filter-data="otherFilters" />
  </div>
</template>

<script lang="ts" setup>
import UiButton from '@sephora-asia/ui-button/UiButton.vue'
import UiDivider from '@sephora-asia/ui-divider'
import BrandFilter from './brand-filter.vue'
import PriceFilter from './price-filter.vue'
import TypeFilter from './type-filter.vue'
import OtherFilter from './other-filter.vue'
import { isFilterParamsAvailable } from '~/utils/product-filter/filter-helpers'
import type {
  BrandFilters,
  OtherFilters,
  PriceRangeFilter,
  TypeFilters,
} from '~/types/api/data/product/filter/filter.types'
import useFilterTrackingEvent from '~/composables/utils/product-listing/filter/use-product-listing-filter-tracking'

const COMPONENTS_TO_RESET = 2

defineProps<{
  brandFilters: BrandFilters[]
  priceRangeFilter: PriceRangeFilter
  otherFilters: OtherFilters[]
  typeFilters: TypeFilters[]
}>()

const { selectedFilterParams, clearAllSelection } =
  useProductListingFiltersStore()

const { trackClearAllFilterClicked } = useFilterTrackingEvent()

const resetComponent = ref(false)
const componentResetTracking = ref<string[]>([])

const isBtnDisabled = computed(
  () => !isFilterParamsAvailable(selectedFilterParams)
)

function onClearAllClicked() {
  trackClearAllFilterClicked()
  resetComponent.value = true
  clearAllSelection()
}

function trackComponentReset(componentType: string) {
  componentResetTracking.value = [
    ...componentResetTracking.value,
    componentType,
  ]
}

watch(componentResetTracking, () => {
  if (componentResetTracking.value.length === COMPONENTS_TO_RESET) {
    resetComponent.value = false
    componentResetTracking.value = []
  }
})
</script>

<style lang="scss" scoped>
.all-filter-container {
  .clear-filter-button {
    width: 100%;
  }
  :deep(.swa-checkbox-container) {
    max-height: 137px;
    overflow-y: auto;
    overflow-x: hidden;
    .checkbox-option {
      margin-bottom: 8px;
      .text-container {
        @extend .body-m;
      }
    }
  }
}
</style>
